import IconBase from "./IconBase";

// A formatted document: a heading above body copy. The ragged last line is
// what separates it from a plain list.
const RichTextIcon = (props) => (
    <IconBase {...props}>
        <path d="M4 5.5h7" />
        <path d="M4 10.5h16" />
        <path d="M4 15h16" />
        <path d="M4 19.5h10" />
    </IconBase>
);

export default RichTextIcon;
